import { render, staticRenderFns } from "./PasswordResetNew.vue?vue&type=template&id=c9c19e8c&scoped=true&"
import script from "./PasswordResetNew.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c19e8c",
  null
  
)

export default component.exports